export const PAIC_VERSIONS_PATH = "/talent-mobility/paic-org-redesign";

// PAIC Org Redesign's role tabs list the version's roles by their status
// exactly as GET /organization-redesign/version/{id} sent it (the draft's
// apiRoleStatuses) — not the normalized design status, which renames
// INCREASED to AI AUGMENTED and turns a REDUCED role at 0 into REDUNDANT.
export const ROLES_REDUCED_API_STATUS = "REDUCED";
export const ROLES_ADDED_API_STATUS = "INCREASED";

export const filterRolesByApiStatus = (roles, apiRoleStatuses, status) =>
  (roles || []).filter((role) => apiRoleStatuses?.[role.sb_unique_id] === status);

// The PAIC plan draft's starting point for one version (see
// usePaicRedesignPlanStore): every role the tabs let the user plan — Roles
// Reduced and Roles Added alike — at its proposed headcount, with its API
// status as change_type (the backend files INCREASED roles under
// roles_increased, the rest under roles_reduced).
export const buildPaicVersionBaseline = ({ plannableRoles, design, apiRoleStatuses }) =>
  (plannableRoles || []).map((role) => ({
    role_key: role.sb_unique_id,
    jd_sb_unique_id: role.jd_sb_unique_id ?? role.sb_unique_id,
    change_type: apiRoleStatuses?.[role.sb_unique_id],
    target_position: design[role.sb_unique_id]?.after_hc ?? role.total_positions,
  }));

// The one organization (org redesign version) a saved plan is edited on:
// the version being opened when the plan has it, else the plan's first —
// the same one View Planning opens. A plan saved before the one-version rule
// can hold several; only this one is loaded, so its Update sends one version
// (the backend rejects more). null when the plan has no visible version.
export const pickPlanOrganization = (organizations, versionId) =>
  (organizations || []).find((organization) => organization.sb_org_redesign_unique_id === versionId) ??
  organizations?.[0] ??
  null;
